import styled from 'styled-components';
import { UptimeBox } from '@uptime/uptime-component';
import DefaultUptimeTheme from 'utils/lumosTheme';
import { SECONDARY_MENU_HEIGHT, TOP_NAV_HEIGHT, TOP_NAV_MOBILE_HEIGHT } from 'components/TopNav/TopNav.style';

type ITheme = typeof DefaultUptimeTheme;

export const StyledIndicator = styled(UptimeBox)`
${({ theme, isHidePrimaryTopNav, isHomePage, isHaveSecondaryTopNav }: { theme: ITheme, isHidePrimaryTopNav: boolean, isHomePage: boolean, isHaveSecondaryTopNav: boolean }) => `
  z-index: 10;
  display: flex;
  justify-content: center;
  position: fixed;
  left: 0;
  right: 0;
  width: 100vw;

  top: ${isHidePrimaryTopNav ? 0 : TOP_NAV_MOBILE_HEIGHT}px;
  @media screen and (min-width: ${theme.breakpoints.md}) {
    top: ${isHidePrimaryTopNav ? 0 : TOP_NAV_HEIGHT}px;
  }

  @media screen and (min-width: ${theme.breakpoints.lg}) {
    top: ${isHidePrimaryTopNav ? 0 : isHomePage ? TOP_NAV_HEIGHT : (TOP_NAV_HEIGHT + (isHaveSecondaryTopNav ? SECONDARY_MENU_HEIGHT : 0))}px;
  }
`}`;

export const StyledBoxIndicator = styled(UptimeBox)(
  ({ theme }: { theme: ITheme }) => `
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    min-height: 48px;
    background-color: ${theme.uptimeColors.mainTheme.light};
    box-shadow: 0px 4px 0px ${theme.uptimeColors.mainTheme.primary};
    margin-bottom: 4px;
    .indicator-description {
      font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
      font-weight: bold;
      line-height: ${theme.uptimeLineHeights.desktop.lh5}px;
      color: ${theme.uptimeColors.textColors.primary};
      word-break: break-all;
    }
`);
